// Seed data for the Crude HPS List (dummy — no backend contract yet).

import { MAIN_STATUS, HPS_STATUS } from './hpsConstants';

const PROCUREMENT_TYPE = 'Hydrocarbon Crude & Condensate';

const RAW_SEED = [
  {
    procId: 'CRUDE-05012026-0001',
    hpsNo: '-',
    title: 'Q1 Arabian Light Term Supply',
    procurementMethod: 'Pelelangan Khusus',
    description: 'Term contract supply of Arabian Light for RU III.',
    mainStatus: MAIN_STATUS.PLANNING,
    hpsStatus: HPS_STATUS.NOT_AVAILABLE,
  },
  {
    procId: 'CRUDE-12012026-0002',
    hpsNo: '-',
    title: 'SPOT Basrah Light February',
    procurementMethod: 'Pemilihan Langsung',
    description: 'One-off spot cargo of Basrah Light for RU IV Cilacap.',
    mainStatus: MAIN_STATUS.PROCUREMENT,
    hpsStatus: HPS_STATUS.NOT_AVAILABLE,
  },
  {
    procId: 'CRUDE-10022026-0002',
    hpsNo: '-',
    title: 'Condensate Senipah Term',
    procurementMethod: 'Pelelangan Khusus',
    description: 'Term supply of Senipah Condensate.',
    mainStatus: MAIN_STATUS.PROCUREMENT,
    hpsStatus: HPS_STATUS.NOT_AVAILABLE,
  },
  {
    procId: 'CRUDE-03032026-0001',
    hpsNo: '-',
    title: 'Murban Crude March Term',
    procurementMethod: 'Pelelangan Khusus',
    description: 'March term supply of Murban Crude.',
    mainStatus: MAIN_STATUS.TENDER_OPENING,
    hpsStatus: HPS_STATUS.NOT_AVAILABLE,
  },
  {
    procId: 'CRUDE-15032026-0002',
    hpsNo: 'HPS-15032026-0001',
    title: 'Basrah Heavy Evaluation Batch',
    procurementMethod: 'Pemilihan Langsung',
    description: 'Evaluation batch for Basrah Heavy.',
    mainStatus: MAIN_STATUS.HPS,
    hpsStatus: HPS_STATUS.WAITING_FC_REVIEW,
  },
  {
    procId: 'CRUDE-22032026-0003',
    hpsNo: 'HPS-22032026-0002',
    title: 'Duri Crude Annual Term',
    procurementMethod: 'Tunjuk Langsung',
    description: 'Annual term supply of Duri Crude for RU II Dumai.',
    mainStatus: MAIN_STATUS.HPS,
    hpsStatus: HPS_STATUS.WAITING_FC_REVIEW,
  },
  {
    procId: 'CRUDE-04042026-0001',
    hpsNo: 'HPS-04042026-0003',
    title: 'Minas Crude Spot Purchase',
    procurementMethod: 'Pemilihan Langsung',
    description: 'Spot purchase of Minas Crude for Balikpapan.',
    mainStatus: MAIN_STATUS.HPS,
    hpsStatus: HPS_STATUS.WAITING_APPROVAL,
  },
  {
    procId: 'CRUDE-11042026-0002',
    hpsNo: 'HPS-11042026-0004',
    title: 'Arabian Heavy Blend Trial',
    procurementMethod: 'Tunjuk Langsung',
    description: 'Trial cargo of Arabian Heavy blend.',
    mainStatus: MAIN_STATUS.HPS,
    hpsStatus: HPS_STATUS.WAITING_APPROVAL,
  },
  {
    procId: 'CRUDE-19042026-0003',
    hpsNo: 'HPS-19042026-0005',
    title: 'Basrah Light May Term',
    procurementMethod: 'Pelelangan Khusus',
    description: 'May term supply of Basrah Light for RU IV.',
    mainStatus: MAIN_STATUS.HPS,
    hpsStatus: HPS_STATUS.COMPLETED,
  },
  {
    procId: 'CRUDE-27042026-0004',
    hpsNo: 'HPS-27042026-0006',
    title: 'Murban Crude Q2 Supply',
    procurementMethod: 'Pemilihan Langsung',
    description: 'Q2 supply of Murban Crude for RU V Balikpapan.',
    mainStatus: MAIN_STATUS.HPS,
    hpsStatus: HPS_STATUS.COMPLETED,
  },
  {
    procId: 'CRUDE-06052026-0001',
    hpsNo: '-',
    title: 'Arabian Light Q2 Top-Up',
    procurementMethod: 'Tunjuk Langsung',
    description: 'Additional Arabian Light cargo to cover Q2 shortfall.',
    mainStatus: MAIN_STATUS.PLANNING,
    hpsStatus: HPS_STATUS.NOT_AVAILABLE,
  },
  {
    procId: 'CRUDE-14052026-0002',
    hpsNo: '-',
    title: 'Condensate Senipah Spot',
    procurementMethod: 'Pelelangan Khusus',
    description: 'Spot condensate cargo for RU III Plaju.',
    mainStatus: MAIN_STATUS.TENDER_OPENING,
    hpsStatus: HPS_STATUS.NOT_AVAILABLE,
  },
];

export const SEED_HPS_REQUESTS = RAW_SEED.map((r, i) => ({
  id: r.procId,
  ...r,
  procurementType: PROCUREMENT_TYPE,
  createdDate: new Date(2026, 0, 5 + i * 7).toISOString(),
}));
